import React from "react";
import AdminDisabledField from "features/Admin/components/AdminDisabledField";

const CodesForm = ({ values }) => (
	<div>
		<AdminDisabledField title="Code Analyse" value={values.code} />
		<AdminDisabledField title="Code SIL" value={values.sil_code} />
		<AdminDisabledField title="Code catalogue" value={values.catalog_code} />
		<AdminDisabledField title="LOINC demand" value={values.loinc_demand} />
		<AdminDisabledField title="Code SIL envoi" value={values.sil_envoi} />
		<AdminDisabledField title="Code AES" value={values.code_aes} />
	</div>
);

export default CodesForm;
